/**
 * Sound effect and BGM URLs resolved at build time.
 */
import gemMp3 from "./sounds/gem.mp3?url";
import justFallMp3 from "./sounds/just_fall.mp3?url";
import shieldMp3 from "./sounds/shield.mp3?url";
import shieldBoingMp3 from "./sounds/shield-boing.mp3?url";
import mergeMp3 from "./sounds/merge.mp3?url";
import ding1Mp3 from "./sounds/ding1.mp3?url";
import ding2Mp3 from "./sounds/ding2.mp3?url";
import ding3Mp3 from "./sounds/ding3.mp3?url";
import ding4Mp3 from "./sounds/ding4.mp3?url";
import ding5Mp3 from "./sounds/ding5.mp3?url";
import boulderCrushMp3 from "./sounds/boulder-crush.mp3?url";
import flaskHitMp3 from "./sounds/flask-hit.mp3?url";
import flaskSmashMp3 from "./sounds/flask-smash.mp3?url";
import pickupMp3 from "./sounds/pickup.mp3?url";
import goldOrbMp3 from "./sounds/gold-orb.mp3?url";
import lifeUpMp3 from "./sounds/life-up.mp3?url";
import shakeDropMp3 from "./sounds/shake-drop.mp3?url";
import shrinkMp3 from "./sounds/shrink.mp3?url";
import bgmFallMp3 from "./sounds/bgm-fall.mp3?url";
import bgmShakeMp3 from "./sounds/bgm-shake.mp3?url";
import wheelSpinMp3 from "./sounds/wheel-spin.mp3?url";
import gameRewardMp3 from "./sounds/game-reward.mp3?url";

var SOUND_FILES = {
  "gem.mp3": gemMp3,
  "just_fall.mp3": justFallMp3,
  "shield.mp3": shieldMp3,
  "shield-boing.mp3": shieldBoingMp3,
  "merge.mp3": mergeMp3,
  "ding1.mp3": ding1Mp3,
  "ding2.mp3": ding2Mp3,
  "ding3.mp3": ding3Mp3,
  "ding4.mp3": ding4Mp3,
  "ding5.mp3": ding5Mp3,
  "boulder-crush.mp3": boulderCrushMp3,
  "flask-hit.mp3": flaskHitMp3,
  "flask-smash.mp3": flaskSmashMp3,
  "pickup.mp3": pickupMp3,
  "gold-orb.mp3": goldOrbMp3,
  "life-up.mp3": lifeUpMp3,
  "shake-drop.mp3": shakeDropMp3,
  "shrink.mp3": shrinkMp3,
  "bgm-fall.mp3": bgmFallMp3,
  "bgm-shake.mp3": bgmShakeMp3,
  "wheel-spin.mp3": wheelSpinMp3,
  "game-reward.mp3": gameRewardMp3,
};

/** @param {string} filename manifest entry e.g. `gem.mp3` */
export function resolveSoundFileUrl(filename) {
  if (!filename) return "";
  return SOUND_FILES[filename] || "";
}